import { create } from 'zustand';

import { INITIAL_DOCUMENT_UPLOAD_STATE } from '@/constants';

import type { DocumentUploadStore } from '@/types/document-upload.type';

export const useDocumentUploadStore = create<DocumentUploadStore>(set => ({
  ...INITIAL_DOCUMENT_UPLOAD_STATE,

  setDocumentType: type => set({ documentType: type }),

  setUploadedFile: file => set({ uploadedFile: file }),

  setIsDragOver: isDragOver => set({ isDragOver }),

  setValidationErrors: errors => set({ validationErrors: errors }),

  setWebPageUrl: url => set({ webPageUrl: url, webPageError: null }),

  setWebPageError: error => set({ webPageError: error }),

  setTextName: name => set({ textName: name, textError: null }),

  setTextContent: content => set({ textContent: content, textError: null }),

  setTextError: error => set({ textError: error }),

  clearErrors: () =>
    set({
      validationErrors: [],
      webPageError: null,
      textError: null,
    }),

  reset: () => set(INITIAL_DOCUMENT_UPLOAD_STATE),
}));
